// Detalles de cotizacion

import React, { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TextField,
  Box
} from "@mui/material";
import { getServiceTypeLabel } from "./ServiceType";
import { getQuatationStatusChip, getQuatationStatusConfig } from "./QuatationStatus";
import ClientForm from './ClientForm';
import ContractForm from './ContractForm';
import { apiFetch, apiFetchJson } from "../fetchWrapper";

export default function QuotationsDetails({ quotation, onBack }) {
  const [localQuotation, setLocalQuotation] = useState(quotation);
  const [status, setStatus] = useState(quotation?.status);
  const [notes, setNotes] = useState(quotation?.notes);
  const [showClientForm, setShowClientForm] = useState(false);
  const [showContractForm, setShowContractForm] = useState(false);
  const [draftClient, setDraftClient] = useState(false);
  const [draftContract, setDraftContract] = useState(false);
  const [clients, setClients] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [existingClient, setExistingClient] = useState(null);
  const [existingContract, setExistingContract] = useState(null);

  if (!quotation) {
    return (
      <div>
        <button onClick={onBack}>Volver</button>
        <p>No se ha seleccionado ninguna cotización.</p>
      </div>
    );
  }

  const fetchRelatedData = async () => {
    try {
      const fetchedClients = await apiFetchJson("/api/clients");
      setClients(fetchedClients);

      const client = fetchedClients.find(
        c => c.contactPerson && c.contactPerson.id === localQuotation.contactPerson.id
      );
      setExistingClient(client);

      const fetchedContracts = await apiFetchJson("/api/contracts");
      setContracts(fetchedContracts);

      const contract = fetchedContracts.find(
        c => c.quotationId === localQuotation.id
      );
      setExistingContract(contract);

    } catch (error) {
      console.error("Error fetching related data:", error);
    }
  };

  useEffect(() => {
    fetchRelatedData();
  }, [localQuotation.contactPerson.id]);

  const statusConfig = getQuatationStatusConfig();

  const handleSave = async () => {
    if (status !== localQuotation.status || notes !== localQuotation.notes) {
      try {
        const res = await apiFetch(`/api/quotations/${localQuotation.id}`, {
          method: "PUT",
          body: JSON.stringify({ ...localQuotation, status, notes }),
        });

        if (!res.ok) throw new Error("Error updating quotation");

        // Actualizar el estado local para reflejar los cambios
        setLocalQuotation({ ...localQuotation, status, notes });

      } catch (err) {
        console.error(err);
        alert("No se pudo actualizar el estatus");
      }
    }
  };

  const handleCreateClient = async () => {
    setDraftClient({
      companyName: localQuotation.organizationName,
      contactPerson: {
        id: localQuotation.contactPerson.id,
        firstname: localQuotation.contactPerson.firstname,
        lastnameFirst: localQuotation.contactPerson.lastnameFirst,
        lastnameSecond: localQuotation.contactPerson.lastnameSecond,
        email: localQuotation.contactPerson.email,
        phoneNumber: localQuotation.contactPerson.phoneNumber,
      },
      address: {
        street: "",
        city: "",
        state: "",
        zipCode: localQuotation.zipCode,
      },
      elementsNumber: localQuotation.elementsNumber,
      serviceType: localQuotation.serviceType
    });
    setShowClientForm(true);
  };

  const handleCancelCreateClient = () => {
    setDraftClient(null);
    setShowClientForm(false);
  }

  const handleCreateContract = async () => {
    setDraftContract({
      organizationName: localQuotation.organizationName,
      description: localQuotation.descripcion,
      elementsNumber: localQuotation.elementsNumber,
      serviceType: localQuotation.serviceType,
      notes: localQuotation.notes,
      clientId: existingClient ? existingClient.id : null,
      quotationId: localQuotation.id,
      startDate: localQuotation.startDate,
      endDate: localQuotation.endDate,
    });
    setShowContractForm(true);
  };

  const handleCancelCreateContract = () => {
    setDraftContract(null);
    setShowContractForm(false);
  }

  const handleSaveClient = async () => {
    setDraftClient(null);
    setShowClientForm(false);
    await fetchRelatedData();
  }

  const handleSaveContract = async (contract) => {
    setExistingContract(contract);
    setDraftContract(null);
    setShowContractForm(false);
    await fetchRelatedData();
  }

  return (
    <div style={{ maxWidth: "800px", margin: "20px auto" }}>
      <Button
        sx={{
          mb: 2,
          backgroundColor: "#3f74b1",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#364f6b"
          }
        }}
        onClick={onBack}

      >
        Volver
      </Button>

      <TableContainer style={{ marginBottom: "20px" }}>
        <Table
          sx={{
            '& .MuiTableCell-root': {
              borderBottom: '1px solid #eaeaea',
              py: 1.5,
            }
          }}
        >
          <TableBody>

            <TableRow>
              <TableCell><strong>ID</strong></TableCell>
              <TableCell>{localQuotation.id}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Nombre(s):</strong></TableCell>
              <TableCell>{localQuotation.contactPerson.firstname}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Primer Apellido:</strong></TableCell>
              <TableCell>{localQuotation.contactPerson.lastnameFirst}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Segundo Apellido:</strong></TableCell>
              <TableCell>{localQuotation.contactPerson.lastnameSecond}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell ><strong>Descripción:</strong></TableCell>
              <TableCell>{localQuotation.descripcion}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><strong>Organización:</strong></TableCell>
              <TableCell>{localQuotation.organizationName}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Estatus:</strong></TableCell>
              <TableCell>{getQuatationStatusChip(localQuotation.status)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Email:</strong></TableCell>
              <TableCell>{localQuotation.contactPerson.email}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Teléfono:</strong></TableCell>
              <TableCell>{localQuotation.contactPerson.phoneNumber}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Código Postal:</strong></TableCell>
              <TableCell>{localQuotation.zipCode}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell ><strong>Número de elementos:</strong></TableCell>
              <TableCell>{localQuotation.elementsNumber}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Tipo de servicio:</strong></TableCell>
              <TableCell>{getServiceTypeLabel(localQuotation.serviceType)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ width: 200, verticalAlign: 'top' }}><strong>Nuevo estatus:</strong></TableCell>
              <TableCell>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    gap: 2,
                  }}
                >
                  <Select
                    size="small"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    sx={{
                      minWidth: "180px",
                    }}
                  >
                    {Object.entries(statusConfig).map(([value, data]) => (
                      <MenuItem key={value} value={value}>
                        {data.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      backgroundColor: "#3f74b1",
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: "#364f6b"
                      }
                    }}
                    onClick={handleSave}
                    disabled={status === localQuotation.status && notes === localQuotation.notes}
                  >
                    Guardar
                  </Button>
                </Box>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Observaciones:</strong></TableCell>
              <TableCell>
                <TextField
                  multiline
                  minRows={3}
                  fullWidth
                  size="small"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  variant="outlined"
                />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Fecha:</strong></TableCell>
              <TableCell>{new Date(localQuotation.createdAt).toLocaleString()}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Última actualización:</strong></TableCell>
              <TableCell>{new Date(localQuotation.updatedAt).toLocaleString()}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Crear cliente: </strong></TableCell>
              <TableCell>
                <Button sx={{ marginRight: 2 }}
                  variant="contained"
                  size="small"
                  disabled={localQuotation.status !== 'APPROVED' || existingClient}
                  onClick={() => {
                    handleCreateClient();

                    setTimeout(() => {
                      document.getElementById('client-form')?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                      });
                    }, 100);
                  }}>Crear Cliente</Button>

                <Button
                  variant="contained"
                  size="small"
                  disabled={!existingClient || existingContract}
                  onClick={() => {
                    handleCreateContract();
                    setTimeout(() => {
                      document.getElementById('contract-form')?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                      });
                    }, 100);
                  }}
                >Crear Contrato</Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <div id="client-form">
        {showClientForm && (
          <ClientForm
            client={draftClient}
            onCancel={handleCancelCreateClient}
            onSave={handleSaveClient}
            fromQuotation={true}
          />
        )}
      </div>

      <div id="contract-form">
        {showContractForm && (
          <ContractForm
            contract={draftContract}
            onBack={handleCancelCreateContract}
            onSave={handleSaveContract}
            fromQuotation={true}
          />
        )}
      </div>
    </div>
  );
}
